import React, { useEffect } from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import Hero from '../components/home/Hero';
import ProblemStatement from '../components/home/ProblemStatement';
import Solution from '../components/home/Solution';
import Features from '../components/home/Features';
import Demo from '../components/home/Demo';
import CTA from '../components/home/CTA';
import CalendlyBooking from '../components/home/CalendlyBooking';
import Security from '../components/home/Security';

const Index = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );
    
    const elements = document.querySelectorAll('.reveal');
    elements.forEach(el => observer.observe(el));
    
    return () => {
      elements.forEach(el => observer.unobserve(el));
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-grow">
        <Hero />
        <ProblemStatement />
        <Solution />
        <Features />
        <Security />
        <CTA />
        <Demo />
        <CalendlyBooking />
        
        {/* Contact Section */}
        <section id="contact" className="py-24 bg-gray-50 relative overflow-hidden">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center mb-12">
              <div className="inline-block px-3 py-1 mb-6 bg-blue-100 text-blue-600 rounded-full text-sm font-medium reveal opacity-0 transition-all duration-700 translate-y-8">
                Get In Touch
              </div>
              <h2 className="heading-lg mb-6 reveal opacity-0 transition-all duration-700 translate-y-8" style={{ transitionDelay: '100ms' }}>
                Ready to Transform Your Investment Analytics?
              </h2>
              <p className="text-gray-600 text-lg reveal opacity-0 transition-all duration-700 translate-y-8" style={{ transitionDelay: '200ms' }}>
                Schedule a demo or reach out with any questions. Our team is here to help.
              </p>
            </div>
            
            <div className="max-w-2xl mx-auto bg-white rounded-xl shadow-lg p-8 reveal opacity-0 transition-all duration-700 translate-y-8" style={{ transitionDelay: '300ms' }}>
              <form className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                    <input 
                      type="text" 
                      id="name" 
                      className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                      placeholder="Your name"
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                    <input 
                      type="email" 
                      id="email" 
                      className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                      placeholder="your@email.com"
                    />
                  </div>
                </div>
                
                <div>
                  <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-1">Company</label>
                  <input 
                    type="text" 
                    id="company" 
                    className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                    placeholder="Your company name"
                  />
                </div>
                
                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                  <textarea 
                    id="message" 
                    rows={4} 
                    className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                    placeholder="Tell us how we can help you"
                  ></textarea>
                </div>
                
                <div className="flex flex-col md:flex-row gap-4 items-center justify-between">
                  <div className="flex items-center">
                    <input 
                      type="checkbox" 
                      id="consent" 
                      className="h-4 w-4 border-gray-300 rounded text-blue-600 focus:ring-blue-500"
                    />
                    <label htmlFor="consent" className="ml-2 block text-sm text-gray-600">
                      I agree to receive communications from Portco AI
                    </label>
                  </div>
                  <button 
                    type="submit" 
                    className="bg-blue-600 text-white hover:bg-blue-700 transition-colors px-6 py-3 rounded-md font-medium"
                  >
                    Submit Request
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />

      <style>{`
        .reveal {
          transition-property: opacity, transform;
          transition-duration: 0.7s;
          transition-timing-function: ease-out;
        }
        
        .reveal.visible {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
      `}</style>
    </div>
  );
};

export default Index;
